window.TEV_MAINTENANCE = [
  {
    band_id: "ev_small_hatch",
    vehicle_type: "ev",
    segment: "small_hatch",
    annual_costs_gbp: {
      "0_4_years": 160,
      "5_9_years": 240,
      "10_plus_years": 340
    }
  },
  {
    band_id: "petrol_small_hatch",
    vehicle_type: "petrol",
    segment: "small_hatch",
    annual_costs_gbp: {
      "0_4_years": 190,
      "5_9_years": 290,
      "10_plus_years": 430
    }
  },
  {
    band_id: "ev_compact_suv",
    vehicle_type: "ev",
    segment: "compact_suv",
    annual_costs_gbp: {
      "0_4_years": 190,
      "5_9_years": 290,
      "10_plus_years": 410
    }
  },
  {
    band_id: "petrol_compact_suv",
    vehicle_type: "petrol",
    segment: "compact_suv",
    annual_costs_gbp: {
      "0_4_years": 230,
      "5_9_years": 350,
      "10_plus_years": 500
    }
  },
  {
    band_id: "ev_premium_family",
    vehicle_type: "ev",
    segment: "premium_family",
    annual_costs_gbp: {
      "0_4_years": 260,
      "5_9_years": 390,
      "10_plus_years": 550
    }
  },
  {
    band_id: "petrol_premium_family",
    vehicle_type: "petrol",
    segment: "premium_family",
    annual_costs_gbp: {
      "0_4_years": 320,
      "5_9_years": 470,
      "10_plus_years": 680
    }
  },
  {
    band_id: "diesel_premium_family",
    vehicle_type: "diesel",
    segment: "premium_family",
    annual_costs_gbp: {
      "0_4_years": 360,
      "5_9_years": 520,
      "10_plus_years": 760
    }
  }
  ,
  {
    band_id: "ev_family_suv",
    vehicle_type: "ev",
    segment: "family_suv",
    annual_costs_gbp: {
      "0_4_years": 210,
      "5_9_years": 320,
      "10_plus_years": 460
    }
  },
  {
    band_id: "petrol_family_suv",
    vehicle_type: "petrol",
    segment: "family_suv",
    annual_costs_gbp: {
      "0_4_years": 260,
      "5_9_years": 390,
      "10_plus_years": 560
    }
  }
];